/* RESPONSIBLE TEAM: team-standalone */

import type { KnowledgeHubModalData } from '../definitions';
import type SalesforcePlatform from '../../salesforce';

export default class SalesforceKnowledgeHubModalData implements KnowledgeHubModalData {
  private platform: SalesforcePlatform;

  constructor(platform: SalesforcePlatform) {
    this.platform = platform;
  }

  get integrationWarning() {
    let hasConnection = this.platform.salesforceConfig?.isConnected;
    let hasFinUser = !!this.platform.salesforceConfig?.finSalesforceUserId;

    if (!hasConnection) {
      return 'salesforce-integration' as const;
    }
    if (!hasFinUser) {
      return 'salesforce-fin-user' as const;
    }
    return null;
  }

  get settingsBlockedReason(): string {
    if (this.platform.isConnected === false) {
      return this.platform.intl.t(
        'knowledge-hub.conversational.conversation-extraction-settings.standalone.settings-blocked-reason.no-integration.salesforce',
      );
    }

    if (!this.platform.salesforceConfig?.finSalesforceUserId) {
      return this.platform.intl.t(
        'knowledge-hub.conversational.conversation-extraction-settings.standalone.settings-blocked-reason.no-fin-id',
      );
    }

    return '';
  }
}
